import React from 'react';
import { Modal } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { getProjectDisplayName } from 'utils/smartContent/useAssignTextToProject';
import './TextAssignedToProjectModal.css';

const CheckIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

const TextAssignedToProjectModal = ({
  isOpen,
  onClose,
  onGoToProjects,
  project = null,
}) => {
  const { t } = useTranslation();
  const projectLabel = getProjectDisplayName(project) || t('le projet sélectionné');

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      className="text-assigned-to-project-modal"
      backdrop
      keyboard
      centered
    >
      <div className="text-assigned-to-project-modal-content">
        <div className="text-assigned-to-project-modal-body">
          <div className="text-assigned-to-project-modal-icon-wrap" aria-hidden="true">
            <CheckIcon />
          </div>
          <h2 className="text-assigned-to-project-modal-title">
            {t('Texte ajouté au projet')}
          </h2>
          <p className="text-assigned-to-project-modal-message">
            {t('Le texte a bien été ajouté au projet')}
            {' '}
            <strong>
              «
              {projectLabel}
              »
            </strong>
            .
            {' '}
            {t('Il n\'apparaîtra plus dans la section')}
            {' '}
            <strong>{t('Rédaction')}</strong>
            {' '}
            :
            {' '}
            {t('vous le retrouverez désormais directement dans la section')}
            {' '}
            <span className="text-assigned-to-project-modal-highlight">
              {t('Projets')}
            </span>
            .
          </p>
        </div>
        <div className="text-assigned-to-project-modal-footer">
          <button
            type="button"
            className="text-assigned-to-project-modal-secondary-button"
            onClick={onClose}
          >
            {t('Fermer')}
          </button>
          <button
            type="button"
            className="text-assigned-to-project-modal-primary-button"
            onClick={onGoToProjects}
          >
            {t('Voir dans Projets')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default TextAssignedToProjectModal;
